import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactRequestMutation extends AbstractGraphqlRequest<{
  sent: boolean;
}> {
  protected readonly type: GraphqlRequestType = 'mutation';

  protected override getQuery(payload: any): TypedDocumentNode<any, any> {
    return gql`
      mutation contactUs($payload: ContactInput!) {
        contactUs(payload: $payload)
      }
    `;
  }

  protected override onParseResult(data: any, payload: any) {
    return data.contactUs;
  }
}
